import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type HubspotOnboardingRunStatus = 'running' | 'imported' | 'skipped' | 'failed';
export type HubspotOnboardingRunSource = 'scan' | 'manual';

export type HubspotOnboardingEnrollmentDTO = {
  courseTitle: string;
  courseId?: string;
  sessions: number;
  startDate?: string;
  endDate?: string;
  enrollmentId?: string;
  error?: string;
};

export type HubspotOnboardingRunDTO = {
  _id: string;
  dealId: string;
  dealName?: string;
  status: HubspotOnboardingRunStatus;
  source: HubspotOnboardingRunSource;
  attempts: number;
  studentId?: string;
  studentName?: string;
  studentEmail?: string;
  parentEmail?: string;
  contractId?: string;
  contractAmount?: number;
  contractCurrency?: string;
  enrollments: HubspotOnboardingEnrollmentDTO[];
  warnings: string[];
  error?: string;
  startedAt: string;
  finishedAt?: string;
};

export type HubspotOnboardingScanResultDTO = {
  pipeline: string;
  stage: string;
  dealsInStage: number;
  queued: number;
  alreadyProcessed: number;
};

const BASE = '/admin/hubspot-onboarding';

export const listHubspotOnboardingRuns: ApiDescription = {
  endpoint: `${BASE}/runs`,
  method: RequestsMethod.Get,
};
export type ListHubspotOnboardingRuns = ApiData<unknown, HubspotOnboardingRunDTO[]>;

export const scanHubspotOnboarding: ApiDescription = {
  endpoint: `${BASE}/scan`,
  method: RequestsMethod.Post,
};
export type ScanHubspotOnboarding = ApiData<unknown, HubspotOnboardingScanResultDTO>;

export const importHubspotOnboardingDeal: ApiDescription = {
  endpoint: `${BASE}/import`,
  method: RequestsMethod.Post,
};
export type ImportHubspotOnboardingDeal = ApiData<
  { dealId: string; force?: boolean },
  HubspotOnboardingRunDTO
>;
